<template>
    <div>
      <supplier-add-new
        :is-add-new-supplier-sidebar-active.sync="isAddNewSupplierSidebarActive"
        :id="id"
        :data="supplierData"
        @refetch-data="refetchData"
        v-if="ability.can('update', 'suppliers')"
      >
      </supplier-add-new>

      <b-card no-body class="mb-0">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Show</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>entries</label>
            </b-col>
  
            <!-- Search -->
            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="搜尋..."
                />
                <b-button variant="primary" @click="handleCreate"  v-if="ability.can('create', 'suppliers')">
                  <span class="text-nowrap">新增供應商</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
  
        <b-table
          ref="refSupplierListTable"
          class="position-relative"
          :items="fetchSuppliers"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
        <template #cell(is_active)="data">
          <feather-icon 
          v-if="data.item.is_active && data.item.deleted_at == null"
          icon="CheckIcon"
          size="18"
          class="mr-50 text-success"
          />
      </template>

          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                v-if="ability.can('update', 'suppliers')"
                @click="handleEdit(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改供應商資料</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="ability.can('delete', 'suppliers') && data.item.deleted_at == null"
                @click="confirmDelete(data.item.id)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">刪除</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="
                d-flex
                align-items-center
                justify-content-center justify-content-sm-start
              "
            >
              <span class="text-muted"
                >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} entries</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="
                d-flex
                align-items-center
                justify-content-center justify-content-sm-end
              "
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalSuppliers"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </template>
  
  <script>
  import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
  } from "bootstrap-vue";
  import vSelect from "vue-select";
  import store from "@/store";
  import { ref, onUnmounted, onMounted } from "@vue/composition-api";
  import { avatarText } from "@core/utils/filter";
  import supplierStoreModule from "../supplierStoreModule";
  import useSuppliersList from "./useSuppliersList";
  import SupplierAddNew from "./SupplierListAddNew.vue";
  import Ripple from "vue-ripple-directive";
  
  export default {
    directives: {
      Ripple,
    },
    components: {
      BCard,
      BRow,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,
      vSelect,
      SupplierAddNew,
    },
    methods: {
      handleCreate() {
        this.id = 0;
        this.resetSupplierData();
        this.isAddNewSupplierSidebarActive = true;
      },
      handleEdit(item) {
        this.resetSupplierData();
        this.supplierData = {...item}
        this.supplierData.id = item.id
        this.id = item.id
        this.isAddNewSupplierSidebarActive = true;
      },
      resetSupplierData() {
        this.supplierData = {
          id: 0,
          name: "",
          address: "",
          contacts: "",
          phone: "",
          email: "",
          remark: "",
          is_active: true
        };
      },
      confirmDelete(id) {
        this.$swal({
          title: "確認刪除?",
          text: "您的操作是最終的，您將無法檢索該供應商。",
          showCancelButton: true,
          confirmButtonText: "刪除",
          cancelButtonText: '取消',
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.$store
              .dispatch("supplier/deleteSupplier", { id: id })
              .then((response) => {
                this.$swal({
                  text: response.data.message,
                  icon: "success",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
                this.refetchData();
                this.refetchStatistic();
              })
              .catch((error) => {
                this.$swal({
                  text: JSON.stringify(error.response.data.message),
                  icon: "error",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
              });
          }
        });
      }
    },
    data() {
      return {
        id: 0,
        supplierData: {},
        client_code:'',
        supplier_id: '',
        openModal: false,
      };
    },
    setup() {
      const SUPPLIER_STORE_MODULE_NAME = "supplier";

      if (!store.hasModule(SUPPLIER_STORE_MODULE_NAME))
        store.registerModule(SUPPLIER_STORE_MODULE_NAME, supplierStoreModule);
  
      onUnmounted(() => {
        if (store.hasModule(SUPPLIER_STORE_MODULE_NAME))
          store.unregisterModule(SUPPLIER_STORE_MODULE_NAME);
      });
  
      const isAddNewSupplierSidebarActive = ref(false);
     
      const {
       
        fetchSuppliers,
        tableColumns,
        perPage,
        currentPage,
        totalSuppliers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refSupplierListTable,
        refetchData,
        ability,
      } = useSuppliersList();
  
      return {
        //Sidebar
        isAddNewSupplierSidebarActive,
        fetchSuppliers,
        tableColumns,
        perPage,
        currentPage,
        totalSuppliers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refSupplierListTable,
        refetchData,
        avatarText,
        ability,
      };
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  </style>
  
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  .badge {
    width:100%;
  }
  </style>